import { globalTranslations } from "@futures-platform/i18n";
import {
  initTranslations,
  setLanguage,
  getAccountLanguage,
} from "@futures-platform/i18n";
export const localTranslations = {
  opportunitiesCommentSection: {
    en: "Opportunities",
    fi: "Mahdollisuudet",
  },
  threatsCommentSection: {
    en: "Threats",
    fi: "Uhat",
  },
  actionsCommentSection: {
    en: "Actions",
    fi: "Toimenpiteet",
  },
  commentViewBtn: {
    en: "Comment / View",
    fi: "Kommentoi / Näytä",
  },
  latestNewsTitle: {
    en: "Latest news",
    fi: "Tuoreet uutiset (engl.)",
  },
  clearRatings: {
    en: "Clear ratings",
    fi: "Tyhjennä",
  },
  relatedPhenomenaSection: {
    en: "Related phenomena",
    fi: "Liittyvät ilmiöt",
  },
  charactersRemainingText: {
    en: "characters remaining",
    fi: "merkkiä jäljellä",
  },
  submitCommentModal: {
    en: "SUBMIT",
    fi: "LÄHETÄ",
  },
  editCommentTitle: {
    en: "Edit Comment",
    fi: "Muokkaa kommenttia",
  },
  cancel: {
    en: "CANCEL",
    fi: "PERUUTA",
  },
  save: {
    en: "SAVE",
    fi: "TALLENNA",
  },
  removeComment: {
    en: "REMOVE COMMENT",
    fi: "POISTA KOMMENTTI",
  },
  removeCommentConfirmation: {
    en: "Are you sure you want to remove your comment?",
    fi: "Haluatko varmasti poistaa kommenttisi?",
  },
  removeCommentNoOption: {
    en: "NO, KEEP IT",
    fi: "EN SITTENKÄÄN",
  },
  removeCommentYesOption: {
    en: "YES",
    fi: "KYLLÄ",
  },
  hasYESTagged: {
    en: "YES",
    fi: "KYLLÄ",
  },
  hasNOTagged: {
    en: "NO",
    fi: "EN",
  },
  editPhenomenon: {
    en: "Edit Phenomenon",
    fi: "Muokkaa ilmiötä",
  },
  editted: {
    en: "Edited",
    fi: "Päivitetty",
  },
  Links: {
    en: "Links",
    fi: "Linkit",
  },
  AddAndRemoveTags: {
    en: `Add / remove tags`,
    fi: `Lisää / poista tageja`,
  },
  visitor: {
    en: `Visitor`,
    fi: `Vierailija`,
  },
  crowdSourcedPhenCard: {
    en: `Crowdsourced: `,
    fi: `Joukkoistettu: `,
  },
  yes: {
    en: `Yes`,
    fi: `Kyllä`,
  },
  editHistory: {
    en: `Edit history`,
    fi: `Muokkaa historiaa`,
  },
  editOn: {
    en: `Edited on`,
    fi: `Muokattu`,
  },
  createdby: {
    en: `Created on`,
    fi: `Luotu`,
  },
  by: {
    en: `by`,
    fi: `-`,
  },
  Description: {
    en: `Description`,
    fi: `Kuvaus`,
  },
  Removeevent: {
    en: `Remove event`,
    fi: `Poista tapahtuma`,
  },
  RemoveeventText: {
    en: `Are you sure you want to remove this event permanently from the change log?`,
    fi: `Haluatko varmasti poistaa tämän tapahtuman aikajanalta pysyvästi?`,
  },
  DescriptionMajorChangeLogs: {
    en: `Description for major update`,
    fi: `Kuvaus tehdyistä muutoksista`,
  },
  ShowAsMajorUpdate: {
    en: `Save as major update`,
    fi: `Sisältää merkittäviä muutoksia`,
  },
  Historyandchangelog: {
    en:'History and change log',
    fi: `Historia ja muutokset`,
  },
  ShowHistory: {
    en:'Show history',
    fi: `Näytä historia`,
  },
  HideHistory: {
    en:'Hide history',
    fi: `Kätke historia`,
  },
  relatedScenario: {
    en:'Related scenarios',
    fi: `Liittyvät skenaariot`,
  },
  Created: {
    en:'Created',
    fi: `Luotu`,
  },
  Edited: {
    en:'Edited',
    fi: `Muokattu`,
  },
  on: {
    en:'on',
    fi: `-`,
  },
  editingTextHistory: {
    en:'Write here a brief description why this should be considered as major update.',
    fi: `Tähän voit listata, mitä merkittäviä muutoksia olet tehnyt sisältöön.`,
  },
  lastModified: {
    en: 'Last modified',
    fi: `Päivitetty`,
  },
  spotlightSVG: {
    en: 'Show in spotlight',
    fi: `Avaa Spotlightissa`,
  },
  ShareSVG: {
    en: 'Share',
    fi: `Jaa`,
  },
  UpvoteSVG: {
    en: 'Upvote',
    fi: `Äänestä ylös`,
  },
  DownvoteSVG: {
    en: 'Downvote',
    fi: `Äänestä alas`,
  },
  TranslationSVG: {
    en: 'Translation',
    fi: `Translation`,
  },
  pdfExportTooltip: {
    en: 'Download as PDF',
    fi: 'Lataa PDF',
  },
  StatzonChart: {
    en: 'Statzon Chart',
    fi: `Statzon`,
  },
  videoFormatsTextStatzonChart: {
    en: 'Statzon formats',
    fi: `Statzonformaatit`,
  },
  publicPhenomenon: {
    en: `Make Content Public`,
    fi: `Julkaise sisältö julkisesti`,
  },
  publicPhenomenonDescription: {
    en: `Make this phenomenon publicly available`,
    fi: `Julkaise tämä ilmiö julkisesti`,
  },
  publicPhenomenonConfirmation: {
    en: `Make content public`,
    fi: `Julkaise sisältö julkisesti`,
  },
  unpublicPhenomenonConfirmation: {
    en: `Remove public access from content`,
    fi: `Poista sisältön julkinen saavutettavuus`,
  },
  unpublicPhenomenonConfirmationDescription: {
    en: `If you continue, this content will be visible to all
platform users, including those outside your
organisation.`,
    fi: `Jos jatkat, tämä sisältö näkyy kaikille platform-käyttäjille, mukaan lukien niitä, jotka eivät kuulu organisaasiin.`,
  },
  publicPhenomenonConfirmationDescription: {
    en: `If you continue, this content will not be visible to all
platform users, including those outside your
organisation.`,
    fi: `Jos jatkat, tämä sisältö ei näy kaikille platform-käyttäjille, mukaan lukien niitä, jotka eivät kuulu organisaasiin.`,
  },
  publicPhenomenonConfirmationDescription2: {
    en: `Are you sure you want to publish it?`,
    fi: `Haluatko varmasti julkaista sen?`,
  },
  unpublicPhenomenonConfirmationDescription2: {
    en: `Are you sure you want to remove public access from this content?`,
    fi: `Haluatko varmasti poistaa sisältön julkinen saavutettavuus?`,
  },
  puplishContentConfirmationBtn: {
    en: `PUBLISH`,
    fi: `JULKAISE`,
  },
  unpublishContentConfirmationBtn: {
    en: `UNPUBLISH`,
    fi: `POISTA JULKAINEN SAAVUTTAVUUS`,
  },
  update_recomendation:{
    en: `Update recommendation `,
    fi: `Päivitysehdotus `,
  },
  expand_more_UpdateRecommended: {
    en: `Show more`,
    fi: `Näytä lisää`,
  },
  expand_less_UpdateRecommended: {
    en: `Show less`,
    fi: `Kätke lisätiedot`,
  },
  update_recomendation:{
    en: `Update recommendation at : `,
    fi: `Päivitysehdotus klo: `,
  },
  expand_more_UpdateRecommended: {
    en: `Show more`,
    fi: `Näytä lisää`,
  },
  expand_less_UpdateRecommended: {
    en: `Show less`,
    fi: `Kätke lisätiedot`,
  },
};

export const finalTranslations = {
  ...globalTranslations,
  ...localTranslations,
};
initTranslations(localTranslations);
setLanguage(getAccountLanguage());
